import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { liveUsageMgmtSelectedAccountsSelector } from "../accounts-data/liveUsageMgmtSelectedAccountsSelector";

export const liveUsageMgmtAccountAllReadOnlySelector = createDraftSafeSelector(
  [liveUsageMgmtSelectedAccountsSelector],
  (allAccounts) => {
    return (
      !!allAccounts &&
      !!allAccounts?.every((account) => account.access_type === "read")
    );
  },
);
